__webpack_require__.p = "/DesafioDevQuestPokemon/";